import React from 'react';
import BossyLogo from '../ui/BossyLogo';
import ThemeToggle from '../ui/ThemeToggle';

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Reusable authentication layout component with glassmorphism design
 * Provides consistent styling for all auth screens (login, register, reset password)
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Theme switcher, pinned to the corner so it never disturbs the card flow */}
      <div className="absolute top-4 right-4 z-20">
        <ThemeToggle />
      </div>

      {/* Animated gradient background */}
      <div className="absolute inset-0">
        {/* dark:* shades resolve to the same hex in dark mode, keeping the
            glassmorphism look identical in both themes */}
        <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-700 dark:bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-indigo-700 dark:bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-700 dark:bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
      </div>

      {/* Content container */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <div className="mb-8">
          <BossyLogo className="h-14 gap-2 filter drop-shadow-2xl" />
        </div>

        {/* Form content, directly under the logo */}
        <div className="w-full max-w-sm">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
